<template>
    <div class="accounting-detail-data accounting-invoice-detail">
        <div class="detail-container">
            <div class="detail-section">
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item vertical">
                        <div class="label">摘要</div>
                        <div class="value">
                            <div class="desc-block">{{ documentDetail.description }}</div>
                        </div>
                    </div>
                </div>
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item">
                        <div class="label">系統單號</div>
                        <div class="value">
                            <el-button type="text" @click="openInvoiceDetail(documentDetail.sno)">{{ documentDetail.ioo }}</el-button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">系統單狀態</div>
                        <div class="value"><InvoiceStatusLabel :statusNum="documentDetail.status" /></div>
                    </div>
                    <div class="item">
                        <div class="label">收入項目</div>
                        <div class="value">{{ getHierarchyItemNames(documentDetail.incomeItemNo) }}</div>
                    </div>
                    <div class="item">
                        <div class="label">付款立帳科目</div>
                        <div class="value">
                            <span>{{ documentDetail.accno }} - {{ documentDetail.accnam }}</span>
                            <el-button v-if="isShowChangeAccnoBtn" size="mini" class="tiny-btn" icon="el-icon-edit" @click="openAccnoModifyDialog"></el-button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">付款沖帳科目</div>
                        <div class="value">
                            <span>{{ documentDetail.clearanceAccno }} - {{ documentDetail.clearanceAccnoNam }}</span>
                            <el-button v-if="isShowChangeAccnoBtn" size="mini" class="tiny-btn" icon="el-icon-edit" @click="openClearanceAccnoModifyDialog"></el-button>
                        </div>
                    </div>
                    <div class="item" v-if="isProject">
                        <div class="label">專案</div>
                        <div class="value">
                            <div>{{ documentDetail.projectName }}</div>
                            <!-- <div>#{{ firstProjectPoo }}</div> -->
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">買受人</div>
                        <div class="value">
                            <div>{{ documentDetail.vdR_NAM }}</div>
                            <div>統編：{{ documentDetail.bsn }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 發票開立 -->
            <div class="detail-section">
                <div class="section-title">發票開立</div>
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item">
                        <div class="label">憑證類型</div>
                        <div class="value">
                            <span> {{ getInvoiceTypeText(documentDetail.typ) }} </span>
                            <span v-if="documentDetail.tranInvoiceList && documentDetail.tranInvoiceList.length > 0">(已轉開)</span>
                        </div>
                    </div>
                    <div v-if="!isReimbursement" class="item">
                        <div class="label">發票號碼</div>
                        <div class="value">{{ documentDetail.foo }}</div>
                    </div>
                    <div class="item">
                        <div class="label">{{ isReimbursement ? "核銷日期" : "開立日期" }}</div>
                        <div class="value">{{ documentDetail.foO_DAT | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">{{ isReimbursement ? "核銷金額" : "銷售額(未稅)" }}</div>
                        <div class="value"><Money :v="documentDetail.amt - documentDetail.amT_TAX" :precision="documentDetail.cny === 'TWD' ? null : 4" /></div>
                    </div>
                    <div v-if="!isReimbursement" class="item">
                        <div class="label">稅金</div>
                        <div class="value"><Money :v="documentDetail.amT_TAX" :precision="documentDetail.cny === 'TWD' ? null : 4" /></div>
                    </div>
                    <div class="item">
                        <div class="label">發票含稅總計</div>
                        <div class="value">
                            <Money :v="documentDetail.amt" class="desc-block" :precision="documentDetail.cny === 'TWD' ? null : 4" /><span style="margin-left: 5px">{{ documentDetail.cny }}</span>
                        </div>
                    </div>
                    <div v-if="documentDetail.foO_DIS_CNL" class="item">
                        <div class="label">作廢日期</div>
                        <div class="value red">{{ documentDetail.foO_DIS_CNL_DAT | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <template v-else-if="!!documentDetail.foO_DIS">
                        <div class="item">
                            <div class="label">折讓日期</div>
                            <div class="value red">{{ documentDetail.foO_DIS_DAT | dateFormater("YYYY-MM-dd") }}</div>
                        </div>
                        <div class="item">
                            <div class="label">折讓未稅金額</div>
                            <div class="value red">
                                <Money :v="documentDetail.foO_DIS_AMT - documentDetail.foO_DIS_AMT_TAX" :precision="documentDetail.cny === 'TWD' ? null : 4" />
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">折讓稅額</div>
                            <div class="value red">
                                <Money :v="documentDetail.foO_DIS_AMT_TAX" :precision="documentDetail.cny === 'TWD' ? null : 4" />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <!-- 核銷轉開發票 -->
            <template v-if="isReimbursement">
                <div class="detail-section" v-for="(reimbursement, index) in documentDetail.tranInvoiceList" :key="reimbursement.sno">
                    <div class="section-title">核銷系統單號 #{{ index + 1 }}</div>
                    <div class="accounting-detail-items" style="margin-top: 25px">
                        <div class="item">
                            <div class="label">憑證類型</div>
                            <div class="value">
                                <span> {{ getInvoiceTypeText(reimbursement.typ) }} </span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">發票號碼</div>
                            <div class="value">{{ reimbursement.foo }}</div>
                        </div>
                        <div class="item">
                            <div class="label">開立日期</div>
                            <div class="value">{{ reimbursement.foO_DAT | dateFormater("YYYY-MM-dd") }}</div>
                        </div>
                        <div class="item">
                            <div class="label">銷售額(未稅)</div>
                            <div class="value"><Money :v="reimbursement.tranInvoiceAmount - reimbursement.amT_TAX" /></div>
                        </div>
                        <div class="item">
                            <div class="label">稅金</div>
                            <div class="value"><Money :v="reimbursement.amT_TAX" /></div>
                        </div>
                        <div class="item">
                            <div class="label">發票含稅總計</div>
                            <div class="value">
                                <Money :v="reimbursement.tranInvoiceAmount" class="desc-block" /><span style="margin-left: 5px">{{ reimbursement.cny }}</span>
                            </div>
                        </div>
                        <div v-if="reimbursement.foO_CNL" class="item">
                            <div class="label">作廢日期</div>
                            <div class="value red">{{ reimbursement.foO_CNL_DAT | dateFormater("YYYY-MM-dd") }}</div>
                        </div>
                        <template v-else-if="!!reimbursement.foO_DIS">
                            <div class="item">
                                <div class="label">折讓日期</div>
                                <div class="value red">{{ reimbursement.foO_DIS_DAT | dateFormater("YYYY-MM-dd") }}</div>
                            </div>
                            <div class="item">
                                <div class="label">折讓未稅金額</div>
                                <div class="value red">
                                    <Money :v="reimbursement.foO_DIS_AMT - reimbursement.foO_DIS_AMT_TAX" />
                                </div>
                            </div>
                            <div class="item">
                                <div class="label">折讓稅額</div>
                                <div class="value red">
                                    <Money :v="reimbursement.foO_DIS_AMT_TAX" />
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="isAuth('G06')" style="margin-top: 10px; text-align: right">
                        <el-button size="small" :disabled="isEditing" @click="onGenerateTaxVoucher(reimbursement)">做傳票</el-button>
                    </div>
                </div>
            </template>
            <!-- 入帳明細 -->
            <div class="detail-section">
                <div class="section-title">入帳明細</div>
                <div v-if="documentDetail.incomes && documentDetail.incomes.length === 0">（尚未入帳）</div>
                <table v-if="documentDetail.incomes && documentDetail.incomes.length > 0" cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 25px">
                    <thead>
                        <tr>
                            <th style="width: 85px;">入帳日期</th>
                            <th>入帳方式</th>
                            <th>收款帳戶</th>
                            <th class="right">金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="income in documentDetail.incomes" :key="income.sno">
                            <td>{{ income.bnK_DAT | dateFormater("YYYY-MM-dd") }}</td>
                            <td>{{ getReceiveIncomeTypeText(income.flg, income.receiveIncomeType) }}</td>
                            <td>{{ income.bnK_SNO ? income.bnK_TPC : "" }}</td>
                            <td class="right">
                                <div>
                                    <Money :v="income.flg < 0 ? -income.amount : income.amount" :precision="documentDetail.cny === 'TWD' ? null : 4" />
                                    <span style="font-size: 8pt; margin-left: 5px;">{{ documentDetail.cny }}</span>
                                </div>
                                <div v-if="documentDetail.cny !== 'TWD'" style="font-size: 8pt; line-height: 130%; margin: 3px 0 10px 0; text-align: left; display: inline-block; color: #777;">
                                    <div>
                                        <span>入帳匯率：</span>
                                        <span>{{ income.rat }}</span>
                                    </div>
                                    <div>
                                        <span>約當台幣：</span>
                                        <span><Money :v="Math.round(income.amount * income.rat)" style="font-weight: normal;"/> </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <InvoiceDetailDialog @close="handleInvoiceDetailDialogClose" :visible="invoiceDetailDialog.visible" :sno="invoiceDetailDialog.sno" />
        <PaymentAccnoModifyDialog
            :typ="1"
            :unT_NBR="documentDetail.ioo"
            :itemSno="documentDetail.incomeItemNo"
            :accno="documentDetail.accno"
            :visible="accnoModifyDialog.visible"
            @accno-changed="$emit('detail-data-changed')"
            @regenerate-vouchers="$emit('regenerate-vouchers')"
            @close="handleAccnoModifyDialogClose"
        />
        <ClearanceAccnoModifyDialog
            :typ="1"
            :unT_NBR="documentDetail.ioo"
            :clearance-accno="documentDetail.clearanceAccno"
            :visible="clearanceAccnoModifyDialog.visible"
            @accno-changed="$emit('detail-data-changed')"
            @regenerate-vouchers="$emit('regenerate-vouchers')"
            @close="handleClearanceAccnoModifyDialogClose"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import InvoiceStatusLabel from '@/components/dashboard/Invoice/InvoiceStatusLabel.vue';

export default {
    props: {
        datas: {
            type: Object,
            default: () => {},
        },
        isEditing: Boolean,
    },
    components: {
        InvoiceStatusLabel,
        InvoiceDetailDialog: () => import('@/components/dashboard/Invoice/InvoiceDetailDialog.vue'),
        PaymentAccnoModifyDialog: () => import('../ui/PaymentAccnoModifyDialog.vue'),
        ClearanceAccnoModifyDialog: () => import('../ui/ClearanceAccnoModifyDialog.vue'),
    },
    data() {
        return {
            arriveTypeList: {
                income: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 1, label: '收現金存銀行' },
                    { sno: 2, label: '收現金存零用金' },
                ],
                return: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 2, label: '零用現金退費' },
                ],
            },
            invoiceDetailDialog: {
                visible: false,
                sno: null,
            },

            accnoModifyDialog: {
                visible: false,
            },
            clearanceAccnoModifyDialog: {
                visible: false,
            },
        };
    },
    computed: {
        documentDetail() {
            return this.datas.detail?.item || {};
        },
        isProject() {
            return this.documentDetail.projects?.length > 0;
        },
        firstProjectPoo() {
            return this.documentDetail.projects[0]?.poo;
        },
        isReimbursement() {
            return this.documentDetail.typ === 4;
        },

        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        userGrP_NO() {
            return this.$store.getters['account/userGrP_NO'];
        },
        isShowChangeAccnoBtn() {
            if (this.userGrP_NO === 'OT1' || this.userGrP_NO === 'OT6') {
                return false;
            }
            return this.userGrP_NO === 'OT2' || this.userGrP_NO === 'OT3' || this.userGrP_NO === 'OT4' || this.userGrP_NO === 'OT5' || this.isSAAdmin;
        },
    },
    methods: {
        getHierarchyItemNames(itemNo) {
            const hierarchy = [null, null, null];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const t in types) {
                const options = this.$store.getters['statement/statementUiOptions'][types[t].key];
                // eslint-disable-next-line no-restricted-syntax, guard-for-in
                for (const i in options) {
                    const lv1Item = options[i];
                    // eslint-disable-next-line no-restricted-syntax, guard-for-in
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemNo) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
        getReceiveIncomeTypeText(flg, typeSno) {
            const typeList = flg > 0 ? this.arriveTypeList.income : this.arriveTypeList.return;
            return _.find(typeList, ['sno', typeSno]).label;
        },
        tableRowClassName({ row }) {
            if (row.flg < 0) return 'minus-row';
            return '';
        },
        getInvoiceTypeText(typ) {
            if (typ === 1) return 'INVOICE';
            if (typ === 2) return '二聯式發票';
            if (typ === 3) return '三聯式發票';
            if (typ === 4) return '核銷';
            return '';
        },
        openInvoiceDetail(sno) {
            this.invoiceDetailDialog.sno = sno;
            this.invoiceDetailDialog.visible = true;
        },
        handleInvoiceDetailDialogClose(refresh) {
            this.$emit('detailClose', refresh);
            this.invoiceDetailDialog.visible = false;
            this.invoiceDetailDialog.sno = null;
        },
        onGenerateTaxVoucher(data) {
            this.$emit('generate', 'reimbursement-invoice', data);
        },

        openAccnoModifyDialog() {
            // this.accnoModifyDialog.accno = this.documentDetail.accno;
            this.accnoModifyDialog.visible = true;
        },
        openClearanceAccnoModifyDialog() {
            // this.clearanceAccnoModifyDialog.accno = this.documentDetail.accno;
            this.clearanceAccnoModifyDialog.visible = true;
        },
        handleAccnoModifyDialogClose(refresh) {
            this.accnoModifyDialog.visible = false;
            if (refresh) {
                this.$emit('detail-data-changed');
            }
        },
        handleClearanceAccnoModifyDialogClose(refresh) {
            this.clearanceAccnoModifyDialog.visible = false;
            if (refresh) {
                this.$emit('detail-data-changed');
            }
        },
    },
};
</script>

<style lang="scss" >
.accounting-detail-data.accounting-invoice-detail .value.red {
    color: #eb5757;
}
</style>
